import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const SYSTEM_ITEMS = ['Los 6 Tomos del Sistema OFM', 'Sistema completo de diagnóstico paso a paso', 'Método para seleccionar el aparato correcto', 'Matrices clínicas de decisión', 'Diagramas de análisis facial', 'Protocolos de evaluación funcional', 'Checklists de consulta', 'Protocolos de seguimiento'];
const BONUS_ITEMS = ['Guía de Rescate Clínico', 'Masterclass: Los 3 Errores que Sabotean el Crecimiento', 'Guía para Laboratorio', 'Consentimientos Profesionales', 'Calculadora de Rentabilidad'];
export function Offer() {
  return <section id="oferta" className="w-full bg-ofm-900 px-5 py-14 sm:px-6 sm:py-20" data-id="element-154" data-mp="ywmyw9rfi841">
      <div className="mx-auto w-full max-w-2xl" data-id="element-155" data-mp="2famuj8j8rblh">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-156" data-mp="2add5htzrl1y6">
          Todo lo que recibirás hoy
        </h2>

        <div className="mt-8 space-y-4" data-id="element-157" data-mp="pmbhhx00j86k">
          <div className="rounded-2xl bg-white p-5 sm:p-6" data-id="element-158" data-mp="uisg5l4u94xw">
            <h3 className="font-display text-lg font-bold text-ofm-900 sm:text-xl" data-id="element-159" data-mp="ulem5gc2zce0">
              Sistema de Decisión Clínica OFM
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-160" data-mp="13k9twwurwujf">
              {SYSTEM_ITEMS.map(item => <li key={item} className="flex gap-2.5" data-id="element-161" data-mp="6u9733dyso4r">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ofm-600" aria-hidden="true" data-id="element-162" data-mp="6rms4ioqv6ci" />
                  <span className="text-[14px] leading-snug text-ofm-900/80" data-id="element-163" data-mp="ftcrcaovb9ku">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-gold/15 p-5 ring-1 ring-gold/40 sm:p-6" data-id="element-164" data-mp="3k7kqaqvpzild">
            <h3 className="font-display text-lg font-bold text-gold sm:text-xl" data-id="element-165" data-mp="3o9pdp7vkrizk">
              Además recibirás GRATIS
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-166" data-mp="ve63ofsftzvx">
              {BONUS_ITEMS.map(item => <li key={item} className="flex gap-2.5" data-id="element-167" data-mp="qfuso1qepjc4">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-168" data-mp="155afx7qqb6n2" />
                  <span className="text-[14px] leading-snug text-ofm-100" data-id="element-169" data-mp="1078y0q51hdd6">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-3xl bg-white p-5 shadow-2xl sm:p-8" data-id="element-170" data-mp="7itlca9dr750">
          <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-ofm-600" data-id="element-171" data-mp="lhb7i3jn0bkt">
            Oferta especial de lanzamiento
          </p>

          <dl className="mt-5 divide-y divide-ofm-100 border-y border-ofm-100" data-id="element-172" data-mp="hi2c6u8y85n5">
            <div className="flex items-center justify-between gap-3 py-3" data-id="element-173" data-mp="1wv54h26risao">
              <dt className="text-[14px] text-ofm-900/80" data-id="element-174" data-mp="1su342i140a74">
                Sistema de Decisión Clínica OFM
              </dt>
              <dd className="shrink-0 text-[14px] font-bold text-ofm-900/60 line-through" data-id="element-175" data-mp="20d2p0s47y9sl">
                $197 USD
              </dd>
            </div>
            <div className="flex items-center justify-between gap-3 py-3" data-id="element-176" data-mp="1qgzlpixms542">
              <dt className="text-[14px] text-ofm-900/80" data-id="element-177" data-mp="1qiu8l2sgq7as">5 Bonos Exclusivos</dt>
              <dd className="shrink-0 text-[14px] font-bold text-ofm-900/60 line-through" data-id="element-178" data-mp="1vfsy1816lq2n">
                $155 USD
              </dd>
            </div>
            <div className="flex items-center justify-between gap-3 py-3" data-id="element-179" data-mp="2o4hs4n3tkv4w">
              <dt className="text-[14px] font-extrabold uppercase tracking-wide text-ofm-900" data-id="element-180" data-mp="29fbzjhzhm35z">
                Valor total
              </dt>
              <dd className="shrink-0 text-[15px] font-extrabold text-ofm-900/60 line-through" data-id="element-181" data-mp="2ed3ygvyjupjo">
                $352 USD
              </dd>
            </div>
          </dl>

          <div className="mt-6 text-center" data-id="element-182" data-mp="36v9bmhhiu1x0">
            <p className="text-[14px] leading-relaxed text-ofm-900/70" data-id="element-183" data-mp="36w0tyqm3y35c">
              Hoy no pagarás $352 USD.
              <br data-id="element-184" data-mp="1j4bhlizvo3k2" />
              Ni siquiera pagarás $97 USD.
            </p>
            <p className="mt-4 text-[12px] font-bold uppercase tracking-[0.14em] text-ofm-600" data-id="element-185" data-mp="1e5qglhcsxfuk">
              Acceso inmediato por solo
            </p>
            <p className="mt-1 font-display text-[54px] font-extrabold leading-none text-ofm-900 sm:text-7xl" data-id="element-186" data-mp="149dnakl6540c">
              $12<span className="text-[32px] sm:text-5xl" data-id="element-187" data-mp="21x5l9gs1w98z">.99</span>
              <span className="ml-1 align-top text-base font-bold text-ofm-600 sm:text-xl" data-id="element-188" data-mp="1wxszz0gtva8i">
                USD
              </span>
            </p>
            <p className="mt-3 text-[13px] font-semibold leading-relaxed text-ofm-900/70" data-id="element-189" data-mp="1s619sr1l36iw">
              Pago único. Sin mensualidades. Sin renovaciones. Acceso para siempre.
            </p>
          </div>

          <div className="mt-5 flex items-start gap-2 rounded-xl bg-ofm-50 p-3.5" data-id="element-190" data-mp="2ko5ggzq52fap">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-ofm-600" aria-hidden="true" data-id="element-191" data-mp="2fvm2w2rgbk5w" />
            <p className="text-[12px] leading-snug text-ofm-900/75 sm:text-[13px]" data-id="element-192" data-mp="2o748kk5ek15l">
              <span className="font-bold" data-id="element-193" data-mp="2s7epusynadzr">Cambio de moneda automático:</span> pagas en
              la moneda de tu país sin hacer nada. El sistema convierte el precio
              automáticamente al momento del checkout.
            </p>
          </div>

          <div className="mt-6" data-id="element-194" data-mp="374f53wzngghc">
            <ScarcityBar data-id="element-195" data-mp="373dv7vude017" />
          </div>

          <CTAButton className="mt-6" label="🦷 QUIERO EL SISTEMA OFM POR SOLO $12.99" data-id="element-196" data-mp="372chtkpvt1gb" />

          <div className="mt-5" data-id="element-197" data-mp="3fvz0qa8zqa83">
            <Countdown data-id="element-198" data-mp="3fxs85rrfgyh5" />
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-2.5" data-id="element-199" data-mp="3fytnw9je2957">
            {['Descarga inmediata', 'Acceso de por vida', 'Pago único', 'Garantía de 7 días'].map(item => <li key={item} className="flex items-center gap-1.5 rounded-lg bg-ofm-50 px-2.5 py-2 text-[12px] font-semibold text-ofm-800 sm:text-[13px]" data-id="element-200" data-mp="3uut2m31077jb">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-ofm-600" aria-hidden="true" data-id="element-201" data-mp="307kexc7l94tc" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}